export const SUPPORT_URL = {
  cases: {
    ja: 'https://dfree.biz/cases?categories=professional',
  },
  basics: {
    ja: 'https://dfree.biz/movie/professional-basics',
  },
  U2PManual: {
    ja: 'https://dfree.biz/img/pdf/professional_manual_U5.pdf',
  },
  U2Manual: {
    ja: 'https://dfree.biz/img/pdf/professional_manual.pdf',
  },
  BenManual: {
    ja: 'https://dfree.biz/img/pdf/professional_manual_Ben.pdf',
  },
  howToWear: {
    ja: 'https://dfree.biz/product#wearing',
    en: 'https://www.youtube.com/watch?v=F8cswb_SCQU',
  },
  troubleshooting: {
    ja: 'https://dfree.biz/professional/support',
  },
  faq: {
    ja: 'https://tayori.com/faq/1b4d9ef23e7016eb3994162ac6bc306754e84a1f/',
  },
  contact: {
    ja: 'https://docs.google.com/forms/d/e/1FAIpQLSf8ToQgopoDI-Pdq07kjvNZcLZeNiOAVP78iqh3P6QTyfjfBQ/viewform',
  },
  instructionManual: {
    ja: 'https://medical.dfree.biz/pdf/viewer_usage_guide.pdf',
    en: 'https://medical.dfree.biz/pdf/viewer_usage_guide.pdf',
  },
  medBasicUsage: {
    ja: 'https://medical.dfree.biz/how-to-use/',
    en: 'https://medical.dfree.biz/how-to-use/',
  },
  medTroubleshooting: {
    ja: 'https://medical.dfree.biz/troubleshooting/',
    en: 'https://medical.dfree.biz/troubleshooting/',
  },
  advice: {
    ad1: {
      ja: 'https://dfree.biz/professional/support#basics_05_01',
    },
    ad4: {
      ja: 'https://dfree.biz/professional/support#practice_03',
    },
    ad5: {
      ja: 'https://dfree.biz/professional/support#practice_04',
    },
  },
};
